import React, { useCallback, useState } from "react";

export function useFieldAppPhotoPreview() {
  const [previewUrl, setPreviewUrl] = useState(null);

  const openPhoto = useCallback((url) => {
    if (url) {
      setPreviewUrl(url);
    }
  }, []);

  const closePhoto = useCallback(() => {
    setPreviewUrl(null);
  }, []);

  return { previewUrl, openPhoto, closePhoto };
}

export function FieldAppPhotoPreviewModal({ url, onClose, t, title, alt }) {
  if (!url) {
    return null;
  }

  return (
    <div
      className="operation-fuel-photo-modal"
      role="dialog"
      aria-modal="true"
      aria-label={title || t("Foto do painel")}
      onClick={onClose}
    >
      <div
        className="operation-fuel-photo-modal-content"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="btn btn-default btn-sm operation-fuel-photo-close"
          onClick={onClose}
        >
          {t("Fechar")}
        </button>
        <img
          src={url}
          alt={alt || t("Foto do painel do horímetro/hodômetro")}
          className="operation-fuel-photo-image"
        />
      </div>
    </div>
  );
}

export function FieldAppFuelPhotoButton({ photoUrl, hasPhoto, onOpenPhoto, t }) {
  if (!hasPhoto && !photoUrl) {
    return "—";
  }

  return (
    <button
      type="button"
      className="field-app-fuel-photo-btn"
      onClick={() => onOpenPhoto(photoUrl)}
      disabled={!photoUrl}
      title={
        photoUrl
          ? t("Abrir foto enviada pelo operador")
          : t("Foto registrada, mas URL indisponível")
      }
    >
      📷 {photoUrl ? t("Ver foto") : t("Sim")}
    </button>
  );
}
